module.exports = __webpack_public_path__ + "img/goldregen-2020-016.4db49fdf.jpg";